/**
 * Reviews from the Ivy League Painting Google Business Profile, newest first.
 * Pulled on Sep 24, 2026 (29 reviews, all 5 stars). Text is as written by each reviewer.
 * To refresh: re-pull the profile's reviews and replace this list.
 */
export type GoogleReview = {
  id: string;
  name: string;
  /** ISO date the review was posted */
  date: string;
  stars: number;
  text: string;
};

export const GOOGLE_RATING = 5.0;
export const GOOGLE_REVIEW_COUNT = 29;
export const GOOGLE_PLACE_ID = 'ChIJF4GISw-B7acRi1CcHhj0I0o';
export const GOOGLE_WRITE_REVIEW_URL = `https://search.google.com/local/writereview?placeid=${GOOGLE_PLACE_ID}`;
export const GOOGLE_REVIEWS_URL = 'https://www.google.com/maps?cid=5342381967421493387';

export const googleReviews: GoogleReview[] = [
  {
    id: 'cw-2026-09-02',
    name: 'C W',
    date: '2026-09-02',
    stars: 5,
    text: 'Best price by far; pleasant guys who don’t leave until you are completely satisfied! Not surprised they’ve been voted #1 in Delta. Well earned :)',
  },
  {
    id: 'sharon-jacobs',
    name: 'Sharon Jacobs',
    date: '2026-09-02',
    stars: 5,
    text: 'We are very pleased with the paint job. The attention to detail was excellent. Thank you, Jack.',
  },
  {
    id: 'rick-ratzlaff',
    name: 'Rick Ratzlaff',
    date: '2026-09-01',
    stars: 5,
    text: 'We had the exterior of our house painted by Ivy League Painters. Henry was our contact and he addressed any concerns we had. Was easy to work with. The painting crew were great and did a fantastic job, from prep to clean up. I would recommend these guys to anyone looking to have painting done, exterior or interior.',
  },
  {
    id: 'ava-groves',
    name: 'Ava Groves',
    date: '2026-08-29',
    stars: 5,
    text: 'Henry Stewart is an excellent project manager for the Ivy League painting company. We were thrilled with the work done for our home and will be using them again.',
  },
  {
    id: 'davina-grant',
    name: 'Davina Grant',
    date: '2026-08-28',
    stars: 5,
    text: 'I have had painting services a few times and the results have always been great. Henry is professional and knowledgeable, and we have always been very happy with the results.',
  },
  {
    id: 'bernie-raverty',
    name: 'Bernie Raverty',
    date: '2026-08-28',
    stars: 5,
    text: 'Great job painting the exterior of our house. No surprise add on costs and the yard was left spotless upon completion. Happily recommend Ivy League Painting.',
  },
  {
    id: 'stewart-wallis',
    name: 'Stewart Wallis',
    date: '2026-08-27',
    stars: 5,
    text: 'Although the job was started later than wanted, the results were excellent. Neat and tidy. Finished on time specified.',
  },
  {
    id: 'stan-baldwin',
    name: 'Stan Baldwin',
    date: '2026-08-27',
    stars: 5,
    text: 'Jack, Henry and the entire team is amazing. We had the outside of our house painted. The painters were polite, clean and did a great job. As long time Tsawwassen residents we highly recommend these guys for any painting you need done.',
  },
  {
    id: 'john-boikman',
    name: 'John Boikman',
    date: '2026-05-02',
    stars: 5,
    text: 'Henry was always available to answer our questions, from start to finish. Gurbir’s attention to detail and quality of workmanship was outstanding! If you’re wanting top notch painters, Ivy League is the way to go!',
  },
  {
    id: 'beachgrove-mom',
    name: 'Beachgrove Mom',
    date: '2026-02-28',
    stars: 5,
    text: 'I can highly recommend Henry. He painted a gorgeous feature wall for me in my bedroom, a rich saturated forest green as well gave my bathroom a paint-over, keeping it nice and fresh. Henry is reliable and trustworthy, will have him back for more.',
  },
  {
    id: 'shelby',
    name: 'Shelby',
    date: '2025-06-05',
    stars: 5,
    text: 'Thank you Henry and team for our beautifully painted home!\n\nWe had the exterior of our home painted by Ivy League and we would highly recommend. High quality, competitive pricing, receptive and responsive to our questions and requests, and provided great solutions to our custom dilemmas, i.e. repairing cedar siding with their carpentry team (thanks Max!). We care about our home and wanted to go with the best team, and this was Ivy League! Thanks again!!',
  },
  {
    id: 'kendra-m',
    name: 'Kendra M.',
    date: '2025-06-03',
    stars: 5,
    text: 'I just had my house exterior painted by Ivy League. Was very happy with the experience. Henry was great to deal with and he got us in really quickly and quoted us a fair price. Hussain did most of the painting and he was great, quick and did a good job. I would definitely use them again and would recommend them to others.',
  },
  {
    id: 'justin-sudds',
    name: 'Justin Sudds',
    date: '2025-05-30',
    stars: 5,
    text: 'Had them do the full exterior of our new (and very dated) home. The transformation is incredible and the guys were super pro, very responsive and there were no surprises. Highly recommend!',
  },
  {
    id: 'susan-bains-grewal',
    name: 'Susan Bains-Grewal',
    date: '2025-05-06',
    stars: 5,
    text: 'We hired Henry and Ivy League Painting to paint my mother’s kitchen and they did a very thorough job. They came back a second day when they didn’t have to just to ensure things looked perfect. Very impressed!',
  },
  {
    id: 'ian-miller',
    name: 'Ian Miller',
    date: '2025-04-30',
    stars: 5,
    text: 'My job was fairly small, but tricky. Ivy League’s team was excellent, and I am very pleased with the results.',
  },
  {
    id: 'alan-stovell',
    name: 'Alan Stovell',
    date: '2025-04-29',
    stars: 5,
    text: 'Excellent work and very responsive to our needs. Always very clean with zero mess around the work area. Very satisfied.',
  },
  {
    id: 'georgia-macadams',
    name: 'Georgia MacAdams',
    date: '2025-02-22',
    stars: 5,
    text: 'Henry and Houssin were easy to deal with. The painting was excellent and they completely cleaned up afterwards. We will definitely use Ivy League again.',
  },
  {
    id: 't-springs',
    name: 'T Springs',
    date: '2025-02-04',
    stars: 5,
    text: 'We are thrilled with the incredible paint job and painting experience with Ivy League Painters and project manager Henry Stewart! We threw some challenges their way: 11 foot ceilings, tight fitting closets, not to mention a few giant murals on the wall to deal with, and they handled everything quickly, professionally and with a keen eye to detail. They were true to their proposed time schedule, worked efficiently, arrived and left when they said they would, thus enabling us to move back in quicker than we expected. We highly recommend Henry and his team!!',
  },
  {
    id: 'bal-bains',
    name: 'Bal Bains',
    date: '2025-02-04',
    stars: 5,
    text: 'Great service and very professional. Excellent work, painted our ceiling looks like it’s been sprayed! Walls and doors done very well. We will definitely call again!',
  },
  {
    id: 'l-w',
    name: 'L W',
    date: '2025-02-02',
    stars: 5,
    text: 'They did a great job.',
  },
  {
    id: 'cole-vhelm',
    name: 'Cole VHelm',
    date: '2024-11-19',
    stars: 5,
    text: 'Incredible service, skill, and quality. We had Ivy League paint the entire interior of our home. It now looks like a brand new home (was built in 1967). Great team of talented painters. A pleasure to work with. We highly recommend Ivy League.',
  },
  {
    id: 'belinda-neumann',
    name: 'Belinda Neumann',
    date: '2024-10-30',
    stars: 5,
    text: 'Ivy League Painting Ltd. did a phenomenal job for us. Can’t recommend them enough! And... they’re not just doing South Delta jobs. Check them out for all your interior/exterior painting needs. You won’t regret it.',
  },
  {
    id: 'sean-waymouth',
    name: 'Sean Waymouth',
    date: '2024-07-05',
    stars: 5,
    text: 'Fantastic company from estimate to final product. The staff are friendly, efficient, and the results show the care taken. Prepping the walls, main painting and touch ups lead to fantastic results.',
  },
  {
    id: 'brian-cowan',
    name: 'Brian Cowan',
    date: '2024-04-19',
    stars: 5,
    text: 'Exceptional workmanship and good value. Very pleased with the results of staining the exterior of our house. Will certainly have you do more work in the future.',
  },
  {
    id: 'corilee-cotter',
    name: 'Corilee Cotter',
    date: '2024-03-01',
    stars: 5,
    text: 'I’m really grateful for reaching out to Ivy League Painting in South Delta. I connected with Henry; I was in a bit of a time crunch and he made sure that Ivy League could accommodate my need. The job was done in very good time; always on time and cleanup excellent. I appreciated the help putting my furnishing and electrical plates back into place. I definitely recommend Ivy League for their quick response and more important, the good quality of the work.',
  },
  {
    id: 'nina-weisser',
    name: 'Nina Weisser',
    date: '2024-02-10',
    stars: 5,
    text: 'The Ivy League team did a fantastic job painting the majority of our new house shortly after our move. They also painted our kitchen cupboards which they completed with utmost professionalism. We’re so happy with the refresh of our walls and kitchen and will use Ivy League again for our next project (exterior painting!) :)',
  },
  {
    id: 'simon-fleming',
    name: 'Simon Fleming',
    date: '2024-02-08',
    stars: 5,
    text: 'Great experience. Ivy League worked with us and our ever changing painting wishes. They were very accommodating with our requirements and the jobs were of excellent quality. Will call them again for our next project.',
  },
  {
    id: 'kim-scoville',
    name: 'Kim Scoville',
    date: '2023-06-06',
    stars: 5,
    text: 'After hiring Ivy League to paint the exterior of our home, I feel compelled to share our experience with them. From the onset, it was nothing but an extremely positive experience. Unlike others, who we sought out to obtain quotes for the same work, Ivy League was quick to respond and provide a detailed and extremely competitive quote. Their attention to detail quickly caught our attention.\n\nWithin days of sitting down and reviewing their quote and scope of work with us… they were prepping the house to be painted. Again, their attention to detail was unbelievable. What became apparent was that the only thing that would exceed their attention to detail was the team’s work ethic. They were there every day, on time and worked tirelessly until the end of the day. We were experiencing a heat dome when they were working, with temps exceeding 32C, yet they never slowed down. They worked through the heat and conditions without complaint.\n\nAs an example, we thought that they were finished, but to our surprise they came back to spend time on a piece of trim that they weren’t happy with. We thought it looked amazing, but they went that extra step to make sure everything was perfect.\n\nThey applied quality paint and the end result reflected that. The house looks amazing!!! We could not be any happier!! There were no shortcuts taken, just meticulous, hard work.\n\nI cannot say enough good things about these guys and the work that they do. Professionals, who do amazing work at extremely competitive prices. In fact, their quote was the best of all the companies we canvassed. The end cost was exactly what we were quoted. There were no hidden costs.\n\nIf you want a job done right, with quality products used, by a team of honest, hard working individuals… then you won’t find anyone better than Ivy League Painting.\n\nA shout out to Darren. This young man was amazing. His work ethic and pleasant, professional demeanour did not go unnoticed. He was a rock star!!',
  },
  {
    id: 'hayley-floyd',
    name: 'Hayley Floyd',
    date: '2022-06-24',
    stars: 5,
    text: 'Highly recommend this company. They arrived early and worked hard. They are a great group of young professionals. Would definitely have them back again.',
  },
];

/** "Sep 2026" style label for a review date. */
export const reviewMonth = (iso: string) =>
  new Date(iso + 'T12:00:00').toLocaleDateString('en-CA', { month: 'short', year: 'numeric' });

/** Up to two initials for the avatar circle. */
export const initials = (name: string) =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join('');
